import { ArrowRight, CheckCircle2, MonitorCheck, Play } from "lucide-react";

export function Hero() {
  return (
    <section id="top" className="hero-shell">
      <div className="hero-mesh" aria-hidden="true" />
      <div className="hero-inner">
        <div className="hero-copy-panel">
          <div className="hero-pill">
            <span className="hero-pill-dot" />
            Bring screens to life
          </div>
          <h1 className="hero-title">
            Bring every screen to life.
          </h1>
          <p className="hero-copy">
            PulsePanels is a modern digital signage platform that helps teams
            manage content, pair screens, schedule playlists, and publish
            updates across every display from one central dashboard.
          </p>

          <div className="hero-actions">
            <a href="mailto:admin@pulsepanels.com?subject=PulsePanels%20demo" className="btn-primary btn-xl">
              Book a Demo
              <ArrowRight size={18} aria-hidden="true" />
            </a>
            <a href="#features" className="btn-secondary-light btn-xl">
              View Features
            </a>
          </div>

          <div className="hero-proof-list">
            {["Pair screens", "Preview runtime", "Publish updates"].map((item) => (
              <div key={item}>
                <CheckCircle2 size={17} aria-hidden="true" />
                {item}
              </div>
            ))}
          </div>
        </div>

        <div className="dashboard-composite">
          <DashboardMockup />
          <div className="insight-card insight-card-left">
            <strong>18</strong>
            <span>screens live</span>
          </div>
          <div className="insight-card insight-card-right">
            <strong>6</strong>
            <span>updates ready</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function DashboardMockup() {
  return (
    <div className="mockup-frame" aria-label="PulsePanels dashboard concept">
      <div className="mockup-topbar">
        <div className="mockup-window-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <div className="mockup-topbar-title">PulsePanels Cloud Signage</div>
        <div className="mockup-live">
          <span />
          Live
        </div>
      </div>

      <div className="mockup-body">
        <aside className="mockup-sidebar">
          <img
            src="/brand/03_icon_only_mark_transparent.svg"
            alt=""
            className="mx-auto h-14 w-14"
            aria-hidden="true"
          />
          <div className="mockup-nav is-active">Screens</div>
          <div className="mockup-nav">Channels</div>
          <div className="mockup-nav">Playlists</div>
          <div className="mockup-nav">Media</div>
        </aside>

        <main className="mockup-content">
          <div className="mockup-header-row">
            <div>
              <p className="mockup-label">Workspace</p>
              <h2>Lobby Network</h2>
            </div>
            <button type="button" className="mockup-button">
              Publish
            </button>
          </div>

          <div className="mockup-stats">
            <div>
              <strong>24</strong>
              <span>Screens</span>
            </div>
            <div>
              <strong>18</strong>
              <span>Live</span>
            </div>
            <div>
              <strong>6</strong>
              <span>Updates</span>
            </div>
          </div>

          <div className="mockup-grid">
            <section className="mockup-screen-card">
              <div className="mockup-screen-head">
                <span className="status status-live">Live</span>
                <MonitorCheck size={17} aria-hidden="true" />
              </div>
              <div className="mockup-screen">
                <div className="mockup-screen-main">Main</div>
                <div className="mockup-screen-rail">Weather</div>
                <div className="mockup-screen-footer">Events today</div>
              </div>
              <div className="mockup-screen-meta">
                <strong>Reception Display</strong>
                <span>Channel: Welcome Loop</span>
              </div>
            </section>

            <section className="mockup-panel">
              <div className="mockup-panel-title">
                <Play size={16} aria-hidden="true" />
                Playlist
              </div>
              {["Brand intro", "Safety notice", "Cafe menu"].map((item, index) => (
                <div className="mockup-list-item" key={item}>
                  <span>{index + 1}</span>
                  <p>{item}</p>
                  <em>{index === 0 ? "12s" : index === 1 ? "20s" : "45s"}</em>
                </div>
              ))}
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}
